import PropTypes from 'prop-types';
import React from 'react';
export default class DistrictColumn extends React.Component {
    constructDistrictListComponent(district) {
        let districtListComponentContents;
        if (district.linkToDistrictPartnerPage === true) {
            if (district.canonical) {
                districtListComponentContents =
                    <a href={baseURL + district.canonical}>{district.name}</a>;
            } else {
                districtListComponentContents =
                    <a href={baseURL + 'district/' + district.urlAlias + '/' + district.districtId + '/'}>{district.name}</a>;
            }
        } else {
            districtListComponentContents = district.name;
        }
        return (
            <li key={district.name}>{districtListComponentContents}</li>
        );
    }

    render() {
        const districtComponents = this.props.districtData.map((district) => this.constructDistrictListComponent(district));
        if (!this.props.shouldDisplay()) {
            return null;
        }
        return (
            <div className='col col3'>
                <ul>
                    {districtComponents}
                </ul>
            </div>
        );
    }
}

DistrictColumn.propTypes = {
    districtData: PropTypes.arrayOf(PropTypes.object).isRequired,
    isMobile: PropTypes.bool.isRequired,
    shouldDisplay: PropTypes.func.isRequired,
};
